import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const PrivacyPloicyAPI = createApi({
    reducerPath: "PrivacyPloicyAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");
            headers.set("Content-Type", "application/json");
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getPrivacyPolicyData: builder.query({
            query: () => `admin/privacy-policy`,
        }),
          
        AddPrivacyPolicy:builder.mutation({
            query: (formData) => ({
                url: "admin/privacy-policy",
                method: "POST",
                body: formData,
            }),
        }),

        UpdatePrivacyPolicy:builder.mutation({
            query: ({formData, id}) => ({
                url: `admin/privacy-policy/${id}`,
                method: "POST",
                body: formData,
            }),
        }),

        getTermsandConditionData: builder.query({
            query: () => `admin/terms-conditions`,
        }),
          
        AddTermsandCondition:builder.mutation({
            query: (formData) => ({
                url: "admin/terms-conditions",
                method: "POST",
                body: formData,
            }),
        }),

        UpdateTermsandCondition:builder.mutation({
            query: ({formData, id}) => ({
                url: `admin/terms-conditions/${id}`,
                method: "POST",
                body: formData,
            }),
        }),


        getRefundPolicyData: builder.query({
            query: () => `admin/refund-policy`,
        }),
          
        AddRefundPolicy:builder.mutation({
            query: (formData) => ({
                url: "admin/refund-policy",
                method: "POST",
                body: formData,
            }),
        }),

        UpdateRefundPolicy:builder.mutation({
            query: ({formData, id}) => ({
                url: `admin/refund-policy/${id}`,
                method: "POST",
                body: formData,
            }),
        }),
  

        getShippingPolicyData: builder.query({
            query: () => `admin/shipping-policy`,
        }),
          
        AddShippingPolicy:builder.mutation({
            query: (formData) => ({
                url: "admin/shipping-policy",
                method: "POST",
                body: formData,
            }),
        }),

        UpdateShippingPolicy:builder.mutation({
            query: ({formData, id}) => ({
                url: `admin/shipping-policy/${id}`,
                method: "POST",
                body: formData,
            }),
        }),
  

   
    }),
});

export const { useGetPrivacyPolicyDataQuery, useAddPrivacyPolicyMutation, useUpdatePrivacyPolicyMutation, useGetTermsandConditionDataQuery,useAddTermsandConditionMutation,useUpdateTermsandConditionMutation, useAddRefundPolicyMutation, useUpdateRefundPolicyMutation,useGetRefundPolicyDataQuery, useGetShippingPolicyDataQuery, useAddShippingPolicyMutation, useUpdateShippingPolicyMutation} = PrivacyPloicyAPI;
